import styles from './LoggedInAvatar.module.scss';

export interface LoggedInAvatarProps {
  initials: string;
}

export const LoggedInAvatar = ({ initials }: LoggedInAvatarProps) => (
  <div className={styles.loggedInAvatarContainer}>
    <span className={styles.initials}>{initials}</span>
  </div>
);
